module.exports = __webpack_public_path__ + "crm_static/img/img_right@2x.49c9de92.png";